import React from 'react';
import PropTypes from 'prop-types';

const FileInput = ({ input, style }) => {
  const {
    value,
    ...inputProps
  } = input;

  const handleChange = (e) => {
    input.onChange(e.target.files[0] || {});
  };

  return (
    <input
      {...inputProps}
      style={style}
      type="file"
      onChange={handleChange}
      onBlur={() => {}}
    />
  );
};

FileInput.propTypes = {
  input: PropTypes.object,
  style: PropTypes.object,
};

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/form/FileInput.js